module.exports = __webpack_public_path__ + "img/revisie.46ea4de3.jpg";